Namespace 'Customer.Dashboard'

class Customer.Dashboard.NewCaseView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/new_case']
  id: 'new-case-container'

  events:
    'click #new-case-selector' : 'onNewCase'

  initialize: (@options = {}) ->
    @tabManagerView = @options.tabManagerView

  render: ->
    @$el.html(@template)
    @

  onNewCase: ->
    @_keepCustomerSessionAlive()
    newTicketView = new Customer.Ticket.NewTicketView(_.extend({newCaseView: @}, @options))
    tabView = new Customer.Tabs.NewTicketTabView
      tabbableView: newTicketView
      selected: true
      hide_refresh: true
    @tabManagerView.changeToTab tabView

  refreshSummary: ->
    @newMessageView.modalTab.destroy()
    @newMessageView.remove()
    @newMessageView = undefined

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
